import omit from 'lodash/omit';

export function allIds(state, action) {
  const { itemIds } = action.payload;
  return state.filter(givenId => itemIds.indexOf(givenId) === -1);
}

export function byId(state, action) {
  const { itemIds } = action.payload;

  let newList = { ...state };
  itemIds.forEach((givenId) => {
    newList = omit(newList, givenId);
  });

  return { ...newList };
}
